import React, {Component} from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import NoPage from "../../pages/no-page/component";
import fetchIntercept from 'fetch-intercept';
import {tokenRegister} from "../../services/tokenRegister";
import RouterWrapper from "../router-wrapper/component";
import {userRegister} from "../../services/userRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import Home from "../../pages/home/component";

class Main extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount(){
        this._setInterceptor();
    }

    _setInterceptor(){
        const unregister = fetchIntercept.register({
            request: function (url, config) {
                return [url, config];
            },
            requestError: function (error) {
                return Promise.reject(error);
            },
            response: function (response) {
                if(response.headers.get('X-Jwt-Token')){
                    tokenRegister.set(response.headers.get('X-Jwt-Token'));
                }
                if(response.status === 200){
                    return response;
                }else if(response.status === 401){
                    userRegister.remove();
                    tokenRegister.remove();
                    return Promise.reject(response);
                } else{
                    return Promise.reject(response);
                }
            },
            responseError: function (error) {
                return Promise.reject(error);
            }
        });
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>

                    <Route path="/:market/:lang/:saleschannel" component={RouterWrapper}/>

                    <Route component={Home}/>

                </Switch>
            </BrowserRouter>
        )
    }

}

export default Main


// WEBPACK FOOTER //
// ./src/components/main/component.js